import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default class CreateAddOnButton extends Component {
  constructor (props) {
    super(props);

    this.openCreateAddOnModal = this.openCreateAddOnModal.bind(this);
  }

  openCreateAddOnModal (e) {
    const { index, openModal } = this.props;
    e.preventDefault();

    openModal('createAddOnModal', index);
  }

  render () {
    return (
      <button className="create-add-on-button" onClick={this.openCreateAddOnModal} {...this.props.attributes} >
        <span className="ico icon-add margin-md-right" />
        <FormattedMessage
          id="inbox.create_add_on_button.create"
          defaultMessage="Create add on"
        />
      </button>
    );
  }
}

CreateAddOnButton.propTypes = {
  index: PropTypes.number,
  openModal: PropTypes.func,
  attributes: PropTypes.object
};
